import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';

@Component({
    selector: 'app-dc-select',
    templateUrl: './dc-select.component.html',
    styleUrls: ['./dc-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DcSelectComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class DcSelectComponent extends ControlValueAccessorConnector {
  @Input() label: string;
  @Input() labelId: string;
  @Input() multiple: boolean;
  @Input() searchable: boolean;
  @Input() closeOnSelect: boolean;
  @Input() items: any[];
  @Input() readonly: boolean;
  @Input() checkbox: boolean;
  @Input() placeholder: string;
  @Input() darkMode?: boolean;
  @Input() lightMode?: boolean;
  @Input() loading: boolean;
  @Input() clearable: boolean = false;
  @Input() dropdownPosition: boolean;
  @Input() groupBy: string;
  @Output() disableEvent = new EventEmitter<any>();
  @Output() selected = new EventEmitter<any>();
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}

  onChange(e) {
    if (e !== undefined) {
      this.selected.emit(e.id);
    }
  }
}
